import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { Select } from 'antd';
import $ from 'jquery';
  
  const { Option } = Select

  var optionsSelos = [];
  var optionsSelosData = [];
  var entidadeSelected = null;
  var DropDownCellTipoVasilha = null;
  var thisMySelect = null;
  var opcoes;
  var optionsSelos2 =  []
  function myFunction(selection) {
    optionsSelos = [];
    optionsSelos2 = [];
    (async (e) => {

      entidadeSelected = selection.value != null ? selection.value : $('#id-select-Entidade [name="form-field-name"]').val();

      const data = {"IDEntidade": selection}
      const EtiquetasSeguranca = await services.apiCall.requestApi(
          "/Fiscalizacao/GetSelosSegurancaEntidade",
          data,
          "get"
      );

      console.log('EtiquetasCellSelos');

      if(EtiquetasSeguranca){
        EtiquetasSeguranca.map((Etiqueta, index) => (
          optionsSelos.push(<Option key={index} value={Etiqueta.idSelosSeguranca}>{Etiqueta.numeroSelo}</Option>)
        ));
      }

      const data2 = {"IDEntidade": selection}
      const EtiquetasSeguranca2 = await services.apiCall.requestApi(
          "/Fiscalizacao/GetAllSelosSegurancaEntidade",
          data2,
          "get"
      );

      console.log('EtiquetasCellSelos');

      if(EtiquetasSeguranca2){
        EtiquetasSeguranca2.map((Etiqueta, index) => (
          optionsSelos2.push(<Option key={index} value={Etiqueta.idSelosSeguranca}>{Etiqueta.numeroSelo}</Option>)
        ));
      }
    })();
  };



class SelectCellSelos extends React.Component {
 
 

  static changeValueFromSelect = (e) => {

    myFunction(e);

  }

  handleChangeCertProcSelosSeg = (e) => {

    var dataItemArray = [];

    for(let i = 0; i < e.length; i++){
      if(optionsSelos.find(c=> c.props.value == e[i]) == undefined){
        dataItemArray.push(optionsSelos2.find(c=> c.props.value == e[i]).props)
      }else{
        dataItemArray.push(optionsSelos.find(c=> c.props.value == e[i]).props)
      }
      
    }


    optionsSelosData[this.props.field] = (dataItemArray.length > 0 ? dataItemArray : []);

    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e != null ? e.syntheticEvent : null,
      value: e.length > 0 ? e : null
    });
  }

  render() {
    console.log("SelectCellSelos");

    thisMySelect = this;

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';
    var dataValue = dataItem[field] === null ? '' : dataItem[field];
    if(dataItem[field] == "SelosSeguranca"){
      dataItem[field] = optionsSelosData[field]
      dataValue = dataItem.SelosSeguranca.map((value) => (
        value.value
      ))
    }
   
    var StringArray = "";

    return (
        <td>
            {this.props.dataItem.inEdit ?
            
            <Select
                mode="multiple"
                allowClear
                optionFilterProp="children"
                placeholder="Selecione as Etiquetas de segurança"
                value={dataValue != null && dataValue != "" ? dataValue.map((value) => (
                  optionsSelos.find(c=> c.props.value == value) == undefined ? 
                  optionsSelos2.find(c=> c.props.value == value).props.value :
                  optionsSelos.find(c=> c.props.value == value).props.value 
                )) : undefined}
                onChange={this.handleChangeCertProcSelosSeg}
                style={{ width: "100%" }}>
                {
                  optionsSelos
                }
            </Select>

            : dataValue != null  &&  dataValue != "" ? dataValue.map((value,index) => (
              opcoes = optionsSelos.find(c=> c.props.value == value) == undefined ?  
                <span key={index} className="ant-select-selection-item-content-etiquetas">{optionsSelos2.find(c=> c.props.value == value).props.children}</span> :
                <span key={index} className="ant-select-selection-item-content-etiquetas">{optionsSelos.find(c=> c.props.value == value).props.children}</span>
              )) : undefined}

        </td>
  )};
    
}
export default SelectCellSelos;